export const VIDEO_SIZES = Object.freeze({ FHD: 'FHD', WQHD: 'WQHD' });
